// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fce6f21","453":"c284f77b","455":"10273623"}[chunkId] + ".chunk.js";
};